// @ts-nocheck
import * as React from "react";

const ListView: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 17.9">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M6.316 3.447V1.053C6.316.47 6.787 0 7.368 0h11.58C19.527 0 20 .471 20 1.053v2.394c0 .582-.471 1.053-1.053 1.053H7.368a1.053 1.053 0 0 1-1.052-1.053Zm0 13.4v-2.394c0-.582.471-1.053 1.052-1.053h11.58c.58 0 1.052.471 1.052 1.053v2.394c0 .582-.471 1.053-1.053 1.053H7.368a1.053 1.053 0 0 1-1.052-1.053Zm0-6.7V7.753c0-.582.471-1.053 1.052-1.053h11.58c.58 0 1.052.471 1.052 1.053v2.394c0 .582-.471 1.053-1.053 1.053H7.368a1.053 1.053 0 0 1-1.052-1.053ZM0 3.447V1.053C0 .47.471 0 1.053 0h2.394C4.03 0 4.5.471 4.5 1.053v2.394C4.5 4.03 4.029 4.5 3.447 4.5H1.053A1.053 1.053 0 0 1 0 3.447Zm0 13.4v-2.394C0 13.87.471 13.4 1.053 13.4h2.394c.582 0 1.053.471 1.053 1.053v2.394c0 .582-.471 1.053-1.053 1.053H1.053A1.053 1.053 0 0 1 0 16.847Zm0-6.7V7.753C0 7.17.471 6.7 1.053 6.7h2.394c.582 0 1.053.471 1.053 1.053v2.394c0 .582-.471 1.053-1.053 1.053H1.053A1.053 1.053 0 0 1 0 10.147Z"
            />
        </svg>
    );
};

export default React.memo(ListView);
